"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_PERIODS = void 0;
var core_1 = require("@material-ui/core");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var colorsV2_1 = __importDefault(require("../../../../assets/jss/colorsV2"));
var AnalyticEvents_1 = __importDefault(require("../../../../utils/AnalyticEvents"));
var AccessibleDateInput_1 = __importDefault(require("./AccessibleDateInput"));
var styles_1 = require("./styles");
exports.TIME_PERIODS = [
    {
        value: 'mostRecent',
        startDate: (0, moment_timezone_1.default)().subtract(24, 'hours'),
        endDate: (0, moment_timezone_1.default)()
    },
    {
        value: 'yesterday',
        startDate: (0, moment_timezone_1.default)()
            .subtract(24, 'hours')
            .startOf('day'),
        endDate: (0, moment_timezone_1.default)()
            .subtract(24, 'hours')
            .endOf('day')
    },
    {
        value: 'pastWeek',
        startDate: (0, moment_timezone_1.default)().subtract(7, 'days'),
        endDate: (0, moment_timezone_1.default)()
    },
    {
        value: 'pastMonth',
        startDate: (0, moment_timezone_1.default)().subtract(30, 'days'),
        endDate: (0, moment_timezone_1.default)()
    },
    {
        value: 'past60Days',
        startDate: (0, moment_timezone_1.default)().subtract(60, 'days'),
        endDate: (0, moment_timezone_1.default)()
    },
    {
        value: 'customDates',
        startDate: (0, moment_timezone_1.default)().subtract(1, 'M'),
        endDate: (0, moment_timezone_1.default)()
    }
];
var AccessibleDrawPeriod = function (_a) {
    var startDate = _a.startDate, setStartDate = _a.setStartDate, endDate = _a.endDate, setEndDate = _a.setEndDate, period = _a.period, setPeriod = _a.setPeriod, theme = _a.theme, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b, selectedGame = _a.selectedGame;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var labelProps = {
        useAlternateTextField: true,
        isRequiredLabel: true,
        labelStyle: {
            margin: theme.spacing(2, 0, 0, 2),
            color: colorsV2_1.default.palette.neutralsN700.hex()
        }
    };
    (0, react_1.useEffect)(function () {
        var newPeriod = exports.TIME_PERIODS.find(function (item) { return period === item.value; });
        if (newPeriod) {
            setStartDate(newPeriod.startDate);
            setEndDate(newPeriod.endDate);
        }
    }, [period]);
    var changeStartDate = function (date) {
        return setStartDate((0, moment_timezone_1.default)(date));
    };
    var changeEndDate = function (date) {
        return setEndDate((0, moment_timezone_1.default)(date));
    };
    var updatePeriod = function (event) {
        var _a;
        setPeriod(event.target.value);
        var analyticsevent = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a['AE0117'];
        if (analyticsevent) {
            AnalyticEvents_1.default.logEvent('AE0117', __assign(__assign({}, analyticsevent), { eventCategory: analyticsevent.eventCategory + '_' + (selectedGame === null || selectedGame === void 0 ? void 0 : selectedGame.name.toLowerCase().replace(' ', '_')), eventLabel: event.target.value }));
        }
    };
    return (react_1.default.createElement(core_1.FormControl, { fullWidth: true },
        react_1.default.createElement(core_1.Typography, { variant: 'body1', className: isNewVersion ? classes.inputTitleUpdated : classes.inputLabel }, t('numberChecker.selectDate')),
        react_1.default.createElement(core_1.InputLabel, { className: classes.selectInputLabel, id: "select-label", htmlFor: "date-select" }, t('numberChecker.drawingDate', 'Drawing date')),
        react_1.default.createElement(core_1.Select, { labelId: "select-label", className: isNewVersion ? classes.selectInputUpdated : classes.formInput, value: period, onChange: updatePeriod, autoComplete: "off", id: "date-select" }, exports.TIME_PERIODS.map(function (item) { return (react_1.default.createElement(core_1.MenuItem, { key: item.value, value: item.value }, t("numberChecker.".concat(item.value)))); })),
        period === 'customDates' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: isNewVersion ? 'h6' : 'body1', className: isNewVersion ? classes.inputTitle : classes.inputLabel }, isNewVersion ? t('numberChecker.dateRangeV2') : t('numberChecker.dateRange')),
            react_1.default.createElement(core_1.Box, { className: classes.dateInputContainer },
                react_1.default.createElement(AccessibleDateInput_1.default, { id: "date-start", minDate: (0, moment_timezone_1.default)().subtract(365, 'days'), minDateMessage: t('numberChecker.shouldBeLessThanYear'), maxDate: endDate, maxDateMessage: t('numberChecker.shouldBeBeforeEndDate'), format: 'MMMM Do, YYYY', theme: theme, value: startDate, onChange: changeStartDate, disableFuture: true, dateAriaLabel: "Date Range Input Start", className: isNewVersion ? classes.dateInput : '', label: t('numberChecker.startDate', 'Start Date'), inputProps: {
                        autocomplete: 'off',
                        'aria-required': 'true',
                        'aria-label': 'Date Range Input Start',
                        required: true,
                        autoFocus: false
                    }, InputLabelProps: {
                        htmlFor: 'date-start'
                    }, labelProps: labelProps }),
                react_1.default.createElement(AccessibleDateInput_1.default, { id: "date-end", minDateMessage: t('numberChecker.shouldBeAfterStartDate'), format: 'MMMM Do, YYYY', theme: theme, value: endDate, onChange: changeEndDate, disableFuture: true, dateAriaLabel: "Date Range Input End", className: isNewVersion ? classes.dateInput : '', label: t('numberChecker.endDate', 'Date End'), inputProps: {
                        autocomplete: 'off',
                        'aria-required': 'true',
                        'aria-label': 'Date Range Input End'
                    }, InputLabelProps: {
                        htmlFor: 'date-end'
                    }, labelProps: labelProps }))))));
};
exports.default = AccessibleDrawPeriod;
//# sourceMappingURL=AccessibleDrawPeriod.js.map